// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Txv7","label":"CategoryService_label__49idW","location":"CategoryService_location__3X3il"};